/* eslint-disable react-hooks/exhaustive-deps */
import {
  DrawingManager,
  GoogleMap,
  StandaloneSearchBox,
} from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { getRandomInt } from "../../utils/helpers/numberUtils";
import DrawingMapProps from "../../propInterfaces/DrawingMapProps";
import { Button, Input } from "antd";
import SearchOutlined from "@ant-design/icons/lib/icons/SearchOutlined";

const colors = [
  "#b40056",
  "#3b185a",
  "#c02485",
  "#ffde14",
  "#e83278",
  "#009c9b",
  "#c6d76b",
  "#f39200",
  "#f8eb4c",
  "#546918",
  "#ff8379",
];

const EDITABLE_COLOR = "blue";

export const DrawingMap: React.FunctionComponent<DrawingMapProps> = ({
  zoom,
  regions,
  editableRegions,
  drawable,
  selectedRegionId,
  mapContainerStyle,
  currentPolygon,
  center,
  setCurrentPolygon,
  onFinishDrawing,
}: DrawingMapProps) => {
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [searchBox, setSearchBox] =
    useState<google.maps.places.SearchBox | null>(null);
  const [drawingModes, setDrawingModes] =
    useState<google.maps.drawing.OverlayType | null>(
      google.maps.drawing.OverlayType.POLYGON,
    );

  const fitBoundsForMultiplePolygons = (polygons: google.maps.Polygon[]) => {
    const bounds = new google.maps.LatLngBounds();
    for (const polygon of polygons) {
      const paths = polygon.getPaths();
      paths.forEach(function (path) {
        const ar = path.getArray();
        for (let i = 0, l = ar.length; i < l; i++) {
          bounds.extend(ar[i]);
        }
      });
    }
    map?.fitBounds(bounds);
  };

  useEffect(() => {
    const polygons = [];

    if (regions && map) {
      for (const region of regions) {
        const color = colors[getRandomInt(colors.length)];

        const polygon = new google.maps.Polygon({
          paths: region.path,
          strokeColor: "#000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: color,
          fillOpacity: 0.35,
        });

        polygon.setMap(map);
        polygons.push(polygon);
      }

      if (drawable) {
        fitBoundsForMultiplePolygons(polygons);
      }
    }
  }, [regions]);

  const onPolygonComplete = (
    polygon?: google.maps.Polygon,
    regionId?: number,
  ) => {
    if (regionId) {
      currentPolygon?.setMap(null);
      setCurrentPolygon(null);
    }

    polygon?.setMap(null);

    onFinishDrawing!(polygon ?? currentPolygon!, regionId);
  };

  const handleLoad = (ref: any) => setSearchBox(ref);

  const onPlacesChanged = () => {
    if (
      searchBox &&
      searchBox.getPlaces() !== undefined &&
      searchBox.getPlaces()![0]
    ) {
      map?.setCenter(
        searchBox
          .getPlaces()![0]
          .geometry?.location?.toJSON() as google.maps.LatLngLiteral,
      );
      map?.setZoom(10);
    }
  };

  useEffect(() => {
    if (editableRegions && map) {
      setDrawingModes(null);

      for (var editableRegion of editableRegions) {
        if (editableRegion.id === selectedRegionId) {
          setCurrentPolygon(editableRegion.polygon!);
        }
        editableRegion.polygon!.setMap(map);
      }
    }
  }, [editableRegions]);

  useEffect(() => {
    if (currentPolygon) {
      currentPolygon.setEditable(true);
      currentPolygon.setOptions({ zIndex: 9999 });
    }
  }, [currentPolygon]);

  useEffect(() => {
    if (editableRegions && map) {
      const bounds = new google.maps.LatLngBounds();
      const editableRegion = editableRegions.find(
        (x) => x.id === selectedRegionId,
      );

      if (!editableRegion || !editableRegion?.polygon) return;
      if (currentPolygon) currentPolygon.setEditable(false);

      setCurrentPolygon(editableRegion.polygon);
      const paths = editableRegion.polygon.getPaths();
      paths.forEach(function (path) {
        const ar = path.getArray();
        for (let i = 0, l = ar.length; i < l; i++) {
          bounds.extend(ar[i]);
        }
      });
      map.fitBounds(bounds);
    }
  }, [selectedRegionId]);

  useEffect(() => {
    setDrawingModes(google.maps.drawing.OverlayType.POLYGON);
  }, [drawingModes]);

  return (
    <div>
      <GoogleMap
        id="drawing-manager-example"
        mapContainerStyle={
          mapContainerStyle ?? {
            height: "90vh",
            width: "100%",
          }
        }
        zoom={zoom}
        center={center}
        onLoad={(map: google.maps.Map) => setMap(map)}
      >
        <Button
          onClick={() => onPolygonComplete(currentPolygon!, selectedRegionId)}
          style={{
            display:
              selectedRegionId !== undefined && selectedRegionId > -1
                ? "flex"
                : "none",
            position: "absolute",
            top: 10,
            left: 190,
            zIndex: 10,
            opacity: "90%",
          }}
        >
          Actualizar polígono
        </Button>
        <DrawingManager
          options={{
            drawingControl: drawingModes ? drawable : false,
            drawingControlOptions: {
              drawingModes: [google.maps.drawing.OverlayType.POLYGON],
              position: google.maps.ControlPosition.TOP_RIGHT,
            },
            polygonOptions: {
              fillColor: EDITABLE_COLOR,
              strokeColor: EDITABLE_COLOR,
            },
          }}
          onPolygonComplete={onPolygonComplete}
        />
        <StandaloneSearchBox
          onLoad={handleLoad}
          onPlacesChanged={onPlacesChanged}
        >
          <Input
            type="text"
            placeholder="Ingrese una direccion"
            prefix={<SearchOutlined />}
            style={{
              boxSizing: `border-box`,
              border: `1px solid transparent`,
              width: `300px`,
              height: `38px`,
              padding: `0px 12px`,
              borderRadius: `3px`,
              boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
              fontSize: `14px`,
              outline: `none`,
              textOverflow: `ellipses`,
              position: "absolute",
              right: "65px",
              top: "10px",
            }}
          />
        </StandaloneSearchBox>
      </GoogleMap>
    </div>
  );
};
